import React, { useLayoutEffect, useRef } from 'react';
import { Alert, Button } from 'react-bootstrap';
import { useAuthContext } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const ImpersonationBanner = () => {
  const { isImpersonating, stopImpersonation, loggedInUser } = useAuthContext();
  const navigate = useNavigate();
  const bannerRef = useRef(null);

  useLayoutEffect(() => {
    const root = document.documentElement;
    const property = '--impersonation-banner-height';
    const banner = bannerRef.current;

    if (!isImpersonating || !banner) {
      root.style.setProperty(property, '0px');
      return;
    }

    const updateHeight = () => {
      root.style.setProperty(
        property,
        `${banner.getBoundingClientRect().height}px`
      );
    };

    updateHeight();

    const observer = new ResizeObserver(updateHeight);
    observer.observe(banner);

    return () => {
      observer.disconnect();
      root.style.removeProperty(property);
    };
  }, [isImpersonating]);

  if (!isImpersonating) {
    return null;
  }

  const handleStopImpersonating = () => {
    stopImpersonation();
    navigate('/admin/usuarios', { replace: true });
  };

  return (
    <div
      ref={bannerRef}
      style={{ position: 'sticky', top: 0, zIndex: 1050 }}
    >
      <Alert variant="warning" className="text-center mb-0 rounded-0">
        Você está personificando{' '}
        <strong>{loggedInUser?.nome || 'usuário'}</strong>.
        <Button
          variant="dark"
          size="sm"
          className="ms-3"
          onClick={handleStopImpersonating}
        >
          Voltar para Admin
        </Button>
      </Alert>
    </div>
  );
};

export default ImpersonationBanner;